module.exports = __webpack_public_path__ + "media/application/images/ui/badge-peoples-choice-0b80e2c4f22bf8508c9c28cfc43b68e7.png";